/**
 * Kept apart from `./constants` so the client-messages contracts — which the
 * app imports — do not pull middy, powertools and the wire-message codecs into
 * the frontend bundle. `./constants` re-exports it for server-side callers.
 */
export const FEATURE_NAME = "monitoring";
